<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100%"
      variant="dark"
      id="loader"
      :class="{'fixed-overlay': show }"
    >

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          
        </b-row>
        <br>
        <b-row>
          <b-col cols="12" class="centered-container" >
            <span class="centered-tab">Land Bank Requisition Application</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
          <div style="background-color: #f9f9f9; padding: 8px 12px; border-radius: 8px; box-shadow: 0 0 4px rgba(0,0,0,0.08); width: 100%;">
            <ul style="list-style: none; padding: 0; margin: 0;">
              <li style="display: flex; align-items: center;">
                <span style="margin-right: 8px;">
                  <img
                    src="../assets/pdf-icon-3.png"
                    height="30px"
                    width="30px"
                    alt="PDF Icon"
                  />
                </span>
                <a
                  href="https://www.apdcl.org/website/docs/documents/nre/EoI Land Requisition NRE.pdf"
                  target="_blank"
                  class="blink hover-underline"
                  style="font-weight: 600; color: #d9534f; text-decoration: none; font-size: 15px;"
                >
                  Download EOI Document
                </a>
              </li>
            </ul>
          </div>
          <br/>

			<b-card title=""  style="box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 12px -4px; background-color:white; border-radius: 8px; padding: 20px;"class="mb-2">

        <!--<hr style="border-top: 2px dashed #000; margin: 10px 0;">--> 
      <b-form @submit.prevent="submitForm">
       
  <!-- Add any content you want inside the div here -->
        <div v-if="currentStep === 1"> <!--Applicant Profiles-->
          <div  class="custom-box-shadow mb-2">
            <h4 class="title-style" >Applicant Profile:</h4></div>
            <br>
          <b-row>
            <b-col cols="12" sm="12" md="6" lg="6">
              
              <b-form-group  label-for="applicantName">
                <span class="label"> Registered Name (Individual/Firm) </span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="applicantName"
                  id="applicantName"
                  type="text"
                  maxlength="50"  
                  placeholder="Enter your name"
                  trim
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="applicantEmail">
                <span class="label"> Email </span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="applicantEmail"
                  id="applicantEmail"
                  type="text"
                  maxlength="60"
                  trim  
                  placeholder="Enter your Email"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
		  <b-row>
        <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="applicantMailAddress">
                <span class="label"> Mailing Address </span><span class="text-danger">*</span> :
                <b-form-textarea
                  v-model="applicantMailAddress"
                  id="applicantMailAddress"
                  maxlength="100"  
                  placeholder="Enter your mailing address"
                  trim
                  required
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="applicantPermanentAddress">
                <span class="label"> Permanent/Registered Postal Address  </span><span class="text-danger">*</span> :
                <b-form-textarea
                  v-model="applicantPermanentAddress"
                  id="applicantPermanentAddress"
                  maxlength="100"  
                  placeholder="Enter your Permanent/Registered Postal Address"
                  trim
                  required
                ></b-form-textarea>
              </b-form-group>
              <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-checkbox v-model="isSameAddress" @input="sameAddress" >
                                  Same as Mailing Address
    </b-form-checkbox>
  </b-col>
            
            </b-col>
          
        </b-row>
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="" label-for="applyingAs">
              <span class="label"> Applying as (Select the applicable)</span><span class="text-danger">*</span> :
              <b-form-select
                id="applyingAs"
                v-model="applyingAs"
                :options="applyingOptions"
                required
              ></b-form-select>
            </b-form-group>
            <b-form-group v-if="applyingAs === 'others'" label="Please specify:" label-for="otherText">
                <b-form-input
                  id="otherText"
                  v-model="otherText"
                  required
                ></b-form-input>
                           </b-form-group>
          </b-col>

            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="incorpYear">
                <span class="label"> Year of Incorporation </span><span class="text-danger">*</span> :
                <b-icon
                  icon="info-circle"
                  variant="primary"
                  class="ml-2"
                  v-b-tooltip.hover
                  title="Year must be in YYYY format"
                  style="cursor: pointer;"
                ></b-icon>
                <b-form-input
                  v-model="incorpYear"
                  id="incorpYear"
                  type="number"
                  maxlength="4"  
                  placeholder="Enter Year of Incorporation in YYYY format" trim
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="" label-for="opYears">
              <span class="label"> Number of Years in Operation</span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="opYears"
                  id="opYears"
                  type="number"
                  placeholder="Enter Number of Years in Operation" trim
                  required
                ></b-form-input>
              </b-form-group>
          </b-col>

            <b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="applicantWebsite">
                <span class="label"> Website(if available)</span> :
                <b-form-input
                  v-model="applicantWebsite"
                  id="applicantWebsite"
                  type="text"
                  maxlength="100"  
                  placeholder="Enter your Website (if available)" trim
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
            <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="" label-for="applicantPAN">
              <span class="label"> PAN</span><span class="text-danger">*</span> :
              
                <b-form-input
                  v-model="applicantPAN"
                  id="applicantPAN"
                  type="text"
                  maxlength="10"  
                  oninput="this.value = this.value.toUpperCase() " 
                  placeholder="Enter your Permanent Account Number (PAN)" trim
                  required
                ></b-form-input>
              </b-form-group>
          </b-col>

            <!--<b-col cols="12" sm="12" md="6" lg="6">
              <b-form-group label="Mobile No:" label-for="applicantMobile">
                <b-form-input
                  v-model="applicantMobile"
                  id="applicantMobile"
                  type="number"
                  maxlength="10"  
                  placeholder="Enter your Mobile Number"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>-->
          </b-row>
          <b-row>
            

            <b-col cols="12" sm="12" md="6" lg="6">

              <b-form-group label="" label-for="isGSTRegistered">
    
                <span class="label"> Is the Vendor registered under GST? </span><span class="text-danger">*</span> :
          <b-form-radio-group
            v-model="isGSTRegistered"
            name="isGSTRegistered"
            :options="gstOptions"
            required
          ></b-form-radio-group>
        </b-form-group>
</b-col>

        <b-col v-if="isGSTRegistered === 'Yes'" cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="applicantGST">
                <span class="label"> GSTN </span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="applicantGST"
                  id="applicantGST"
                  type="text"
                  maxlength="15"  
                  oninput="this.value = this.value.toUpperCase() " 
                  placeholder="Enter your GSTN" trim
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group label="" label-for="applicantGSTNadd">
                <span class="label">GSTN Address</span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="applicantGSTNadd"
                  id="applicantGSTNadd"
                  type="text"
                  maxlength="100"  
                  placeholder="Enter your GSTN Address" trim
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          
          </b-row>
          <b-row>
            

            <b-col cols="12" sm="12" md="6" lg="6">

              <b-form-group label="" label-for="isDebarred">
                <span class="label"> Has the Bidder/ Company ever been debarred by any Govt. Dept./ Undertaking for undertaking any work</span><span class="text-danger">*</span> :
          <b-form-radio-group
            v-model="isDebarred"
            name="isDebarred"
            :options="DebarredOptions"
            required
          ></b-form-radio-group>
        </b-form-group>
</b-col>

        <b-col v-if="isDebarred === 'Yes'" cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="debarredDetails">
                <span class="label"> Debarred Details </span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="debarredDetails"
                  id="debarredDetails"
                  type="text"
                  placeholder="Please enter Debarred Details" trim
                  required
                ></b-form-input>
              </b-form-group>
             
            </b-col>
          
          </b-row>
          <b-row>
            

            <b-col cols="12" sm="12" md="6" lg="6">

              <b-form-group label="" label-for="isMsme">
                <span class="label"> Whether company is MSME as on the bidding date</span><span class="text-danger">*</span> :
          <b-form-radio-group
            v-model="isMsme"
            name="isMsme"
            :options="MsmeOptions"
            required
          ></b-form-radio-group>
        </b-form-group>
</b-col>

        <b-col v-if="isMsme === 'Yes'" cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="MsmeDetails">
                <span class="label"> MSME Details </span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="MsmeDetails"
                  id="MsmeDetails"
                  type="text"
                  maxlength="100"  
                  placeholder="Please enter MSME Details" trim
                  required
                ></b-form-input>
              </b-form-group>
             
            </b-col>
          
          </b-row>
  <b-row> 
  <b-col cols="12" sm="12" md="12" lg="12">
  
  <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Details of authorized Contact Person(s) / Fax No. to whom all references shall be made" label-for="AuthorizedPerson" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group></b-col>
  <b-col cols="6" sm="6" md="6" lg="6">
  <b-form-group label="" label-for="Name" >
    <span class="label"> Authorized person Name</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="PoAName"
      id="PoAName"
      type="text"
      maxlength="50"  
      placeholder="Enter Authorized Person Name" trim
      required
    ></b-form-input>
  </b-form-group>
  <b-form-group label="" label-for="PoADesignation:">
    <span class="label">Authorized person Designation</span><span class="text-danger">*</span>:
    <b-form-input
      v-model="PoADesignation"
      id="PoADesignation"
      type="text" 
      maxlength="50"  
      placeholder="Enter Designation" trim
      required
    ></b-form-input>
  </b-form-group>
  <b-form-group label="" label-for="PoAEmailId" >
    <span class="label"> Email ID</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="PoAEmailId"
      id="PoAEmailId"
      type="text" 
      maxlength="50"  
      placeholder="Enter Email Id of the authorized person" trim
      required
    ></b-form-input>
  </b-form-group>
</b-col>
<b-col cols="6" sm="6" md="6" lg="6">
  <b-form-group label="" label-for="PoAPostalAddress:" >
    <span class="label">Postal Address</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="PoAPostalAddress"
      id="PoAPostalAddress"
      type="text" 
      maxlength="100"  
      trim
      placeholder="Enter Postal Address:"
      required
    ></b-form-input>
  </b-form-group>
  <b-form-group label="" label-for="PoAMobileNo" >
    <span class="label">MobileNo</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="PoAMobileNo"
      id="PoAMobileNo"
      type="number"
      maxlength="10"   
      placeholder="Enter Mobile No of the authorized person" trim
      required
    ></b-form-input>
  </b-form-group>
  
</b-col>
            </b-row>


          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-content-center">
              <b-button @click="goToNextStep" variant="primary">Next</b-button>
            </b-col>
          </b-row>
        </div>

        <!-- Step 2: Land Details -->
        <div v-if="currentStep === 2">
          <div  class="custom-box-shadow mb-2">
            <h4 class="title-style" >LAND PROFILE:</h4></div>
            <b-row> 
  <b-col cols="12" sm="12" md="12" lg="12">
  
  <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Basic Land Details" label-for="LandDetails" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;"></b-form-group></b-col></b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="Village" >
    <span class="label">Village</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="Village"
      id="Village"
      type="text"
      maxlength="20"  
      placeholder="Enter Village Name"
      required
    ></b-form-input>
  </b-form-group></b-col>
  <b-col cols="12" sm="12" md="6" lg="6">

    <b-form-group label="" label-for="Tehsil:">
      <span class="label">Tehsil</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="Tehsil"
      id="Tehsil"
      type="text" 
      maxlength="20"  
      placeholder="Enter Tehsil"
      required
    ></b-form-input>
  </b-form-group>
  </b-col>
</b-row>
  
 <b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label="" label-for="State:" >
      <span class="label">State</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="State"
      id="State"
      type="text"
      value="Assam"
      disabled
      required
      
    ></b-form-input>
  </b-form-group></b-col>
  <b-col cols="12" sm="12" md="6" lg="6"><b-form-group label="" label-for="" >
    <span class="label">District</span><span class="text-danger">*</span> :
    <b-form-select
      v-model="District"
      id="District"
      :options="districtOptions"
      required
      placeholder="Select District"
    ></b-form-select>
  </b-form-group></b-col>


 </b-row>
  
  <b-row><b-col cols="12" sm="12" md="6" lg="6"><b-form-group label="" label-for="Coordinates:">
    <span class="label">Coordinates</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="Coordinates"
      id="Coordinates"
      type="text"
      maxlength="100"  
      oninput="this.value = this.value.toUpperCase() "  
      placeholder="Enter Coordinates"
      required
    ></b-form-input></b-form-group>
</b-col>
<b-col cols="12" sm="12" md="6" lg="6">

  <b-form-group label="" label-for="ApproxArea" >
    <span class="label">Approx area Available (Acre)</span><span class="text-danger">*</span> :
    <b-icon
        icon="info-circle"
        variant="primary"
        class="ml-2"
        v-b-tooltip.hover
        title="Leasing of land of minimum 5 Acres (15 bighas) contiguous land for clean energy projects and minimum 1 Acre (3 bigha) contiguous land for manufacturing units in a single location free of all encumbrances."
        style="cursor: pointer;"
      ></b-icon>
    <b-form-input
      v-model="ApproxArea"
      id="ApproxArea"
      type="number"
      maxlength="50"  
      placeholder="Enter Approx area Available (Acre)"
      required
    ></b-form-input>
  </b-form-group></b-col></b-row>
  
  
  <b-row> 
  <b-col cols="12" sm="12" md="12" lg="12">
  
  <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Type of Land (as per revenue records)" label-for="LandType" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group></b-col></b-row>
  <b-row>
            

            <b-col cols="12" sm="12" md="6" lg="6">

              <b-form-group label="" label-for="landCultivable">
                <span class="label">Is the Land Cultivable?</span><span class="text-danger">*</span> :
          <b-form-radio-group
            v-model="isLandCultivable"
            name="isLandCultivable"
            :options="isLandCultivableOptions"
            required
          ></b-form-radio-group>
        </b-form-group>
</b-col>




</b-row>
<b-row>
            

            <b-col cols="12" sm="12" md="6" lg="6"><b-form-group label="" 
            label-for="AgriPermission">
            <span class="label">Is Agricultural Permission Required?</span><span class="text-danger">*</span> :
          <b-form-radio-group
            v-model="isAgriPermission"
          name="isAgriPermission"
            :options="isAgriPermissionOptions"
            required
          ></b-form-radio-group>
        </b-form-group></b-col>
          
            
          
        <b-col v-if="isAgriPermission === 'Yes'" cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="scopeAgriculture">
                <span class="label">Scope of Agricultural Permisison</span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="scopeAgriculture"
                  id="scopeAgriculture"
                  type="text"
                  maxlength="100"  
                  placeholder="Enter details about Scope of Agricultural permission"
                  required
                ></b-form-input>
              </b-form-group>
             
            </b-col>
          </b-row>

          <b-row>
            

            <b-col cols="12" sm="12" md="6" lg="6"><b-form-group label="" 
            label-for="isscstLand">
            <span class="label">SC/ ST land?</span><span class="text-danger">*</span> :
          <b-form-radio-group
            v-model="isscstLand"
          name="isscstLand"
            :options="isscstLandOptions"
            required
          ></b-form-radio-group>
        </b-form-group></b-col>
          
            
          
        <b-col v-if="isscstLand === 'Yes'" cols="12" sm="12" md="6" lg="6">
              <b-form-group label="" label-for="areainAcres">
                <span class="label">Area in Acres</span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="areainAcres"
                  id="areainAcres"
                  type="number"
                  placeholder="Enter details about area in Acres"
                  required
                ></b-form-input>
              </b-form-group>
              <b-form-group label="" label-for="noofSurveys">
                <span class="label">No of surveys</span><span class="text-danger">*</span> :
                <b-form-input
                  v-model="noofSurveys"
                  id="noofSurveys"
                  type="number"
                  maxlength="10"
                  placeholder="Enter No of Surveys conducted"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row> 
            <b-col cols="12" sm="12" md="12" lg="12">
          <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Land ownership details" label-for="LandOwnershipDetails" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group></b-col></b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="ownershipDetails" >
    <span class="label">Ownership details:</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="ownershipDetails"
      id="ownershipDetails"
      type="text"
      maxlength="100"  
      placeholder="Enter Ownership Details"
      required
    ></b-form-input>
  </b-form-group></b-col>
  <b-col cols="12" sm="12" md="6" lg="6">

    <b-form-group label="" label-for="acquisitionStatus:">
      <span class="label">Acquisition Status(Extent of ATS/Sale Deed)</span><span class="text-danger">*</span> :
    
              <b-form-input
      v-model="acquisitionStatus"
      id="acquisitionStatus"
      type="text"
      maxlength="100"  
      placeholder="Enter acquisition Status"
      required
    ></b-form-input>
    
  </b-form-group>
  </b-col>
</b-row>
<b-row> 
            <b-col cols="12" sm="12" md="12" lg="12">
          <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Trees cutting requirement" label-for="Treescuttingrequirement" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group></b-col></b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="treeRequirement" >
    <span class="label">Tentative requirement of tree cutting:</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="treeRequirement"
      id="treeRequirement"
      type="text"
      maxlength="100"  
      placeholder="Enter Tentative requirement of tree cutting"
      required
    ></b-form-input>
  </b-form-group></b-col>
  <b-col cols="12" sm="12" md="6" lg="6">

    <b-form-group label="" label-for="treeTypes:">
      <span class="label">Type of trees:</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="treeTypes"
      id="treeTypes"
      type="text" 
      maxlength="100"  
      oninput="this.value = this.value.toUpperCase() " 
      placeholder="Enter Type of trees"
      required
    ></b-form-input>
  </b-form-group>
  </b-col>
</b-row>
<b-row> 
            <b-col cols="12" sm="12" md="12" lg="12">
          <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Connectivity / Approach to site" label-for="connectivitysite" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group></b-col></b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="noofaccessRoad" >
    <span class="label">Number of Access roads connecting to site</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="noofaccessRoad"
      id="noofaccessRoad"
      type="number"
      placeholder="Enter Number of Access roads connecting to site"
      required
    ></b-form-input>
  </b-form-group></b-col>
  <b-col cols="12" sm="12" md="6" lg="6">

    <b-form-group label="" label-for="majorHighways">
      <span class="label">Nearby Major Highways(National/State Highway/District Roads etc)</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="majorHighways"
      id="majorHighways"
      type="text" 
      maxlength="50"  
      oninput="this.value = this.value.toUpperCase() " 
      placeholder="Enter Nearby Major Highways "
      required
    ></b-form-input>
  </b-form-group>
  </b-col>
</b-row>

<b-row> 
            <b-col cols="12" sm="12" md="12" lg="12">
          <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Physical Status of Land &preliminary Details about strata / topography / terrain" label-for="physicalstatusland" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group></b-col></b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label="" label-for="terrainStatus">
      <span class="label">Flat/Undulated terrain</span><span class="text-danger">*</span> :
              <b-form-select
                id="terrainStatus"
                v-model="terrainStatus"
                :options="terrainStatusOptions"
                required
              ></b-form-select>
            </b-form-group>
  </b-col>
  <b-col cols="12" sm="12" md="6" lg="6">

    <b-form-group label="" label-for="physicalOccupation:">
      <span class="label">Physical occupation status of land</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="physicalOccupation"
      id="physicalOccupation"
      type="text" 
      placeholder="Enter Physical occupation status of land"
      required
    ></b-form-input>
  </b-form-group>
  </b-col>
</b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label="">
      <span class="label">Any existing structures inside the land parcels?</span><span class="text-danger">*</span> :
      <b-form-select
                id="existingStructure"
                v-model="existingStructure"
                :options="existingStructureOptions"
                required
              ></b-form-select>
            </b-form-group>
  </b-col>
  <b-col cols="12" sm="12" md="6" lg="6">

    <b-form-group label="">
      <span class="label">Presence of forest land, protected land, religious land, graveyard etc.?</span><span class="text-danger">*</span>
      <b-form-select
                id="presenceLand"
                v-model="presenceLand"
                :options="presenceLandOptions"
                required
              ></b-form-select>
  </b-form-group>
  </b-col>
</b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label="" label-for="presencewasteArea">
      <span class="label">Presence of any unusable / Waste area (Acre)?</span><span class="text-danger">*</span> :
      <b-form-select
                id="presencewasteArea"
                v-model="presencewasteArea"
                :options="presencewasteAreaOptions"
                required
              ></b-form-select>
            </b-form-group>
  </b-col>
  <b-col cols="12" sm="12" md="6" lg="6">

    <b-form-group label="" label-for="presencegaspipelines">
      <span class="label">Presence of any active gas Pipe lines/ electrical cable network etc.?</span><span class="text-danger">*</span> :
      <b-form-select
                id="presencegaspipelines"
                v-model="presencegaspipelines"
                :options="presencegaspipelinesOptions"
                required
              ></b-form-select>
  </b-form-group>
  </b-col>
</b-row>
<b-row> 
            <b-col cols="12" sm="12" md="12" lg="12">
          <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Power Evacuation & Transmission Line" label-for="powerLine" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group></b-col></b-row>
  <b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="nearestSubstation" >
    <span class="label">Nearest Substation</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="nearestSubstation"
      id="nearestSubstation"
      type="text"
      placeholder="Enter Nearest Substation"
      maxlength="60"  
      required
    ></b-form-input>
  </b-form-group></b-col>
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label="" label-for="ownershipSubstation" >
      <span class="label">Ownership of Substation</span><span class="text-danger">*</span> :
    <b-form-select
      v-model="ownershipSubstation"
      id="ownershipSubstation"
      :options="ownershipSubstationOptions"
      required
      placeholder="Select Ownership of Substation"
    ></b-form-select>
  </b-form-group>
  </b-col>
</b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="coordinatesSubstation" >
    <span class="label">Coordinates of Substation</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="coordinatesSubstation"
      id="coordinatesSubstation"
      type="text"
      maxlength="100"  
      oninput="this.value = this.value.toUpperCase() " 
      placeholder="Enter Coordinates of Substation"
      required
    ></b-form-input>
  </b-form-group></b-col>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="VoltageLevels" >
    <span class="label">Voltage Levels(in KV)</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="voltageLevels"
      id="voltageLevels"
      type="number"
      placeholder="Enter Voltage Levels"
      required
    ></b-form-input>
  </b-form-group></b-col>
</b-row>
<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="aerialDistance" >
    <span class="label">Arial Distance from Site(in Km)</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="aerialDistance"
      id="aerialDistance"
      type="number"
      
      placeholder="Enter Arial Distance from Site"
      required
    ></b-form-input>
  </b-form-group></b-col>
  <b-col cols="12" sm="12" md="6" lg="6">
  <b-form-group label="" label-for="routeLength" >
    <span class="label">Tentative route length from Site(in Km)</span><span class="text-danger">*</span> :
    <b-form-input
      v-model="routeLength"
      id="routeLength"
      type="text"
      placeholder="Enter Tentative route length from Site"
      required
    ></b-form-input>
  </b-form-group></b-col>
</b-row>
<b-row>
  
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label="" label-for="railwayorNHcrossing" >
      <span class="label">Railway/NH crossing?</span><span class="text-danger">*</span> :
    <b-form-select
      v-model="railwayorNHcrossing"
      id="railwayorNHcrossing"
      :options="railwayorNHcrossingOptions"
      required
      placeholder="Select"
    ></b-form-select>
  </b-form-group>
  </b-col>
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label="" label-for="forestCrossing" >
      <span class="label">Forest Crossing?</span><span class="text-danger">*</span> :
    <b-form-select
      v-model="forestCrossing"
      id="forestCrossing"
      :options="forestCrossingOptions"
      required
      placeholder="Select"
    ></b-form-select>
  </b-form-group>
  </b-col>
</b-row>
<b-row>
  
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label="" label-for="populatedAreacrossing" >
      <span class="label">Populated Area crossing?</span><span class="text-danger">*</span> :
    <b-form-select
      v-model="populatedAreacrossing"
      id="populatedAreacrossing"
      :options="populatedAreacrossingOptions"
      required
      placeholder="Select"
    ></b-form-select>
  </b-form-group>
  </b-col>
</b-row>
  <b-row>
      <b-col col cols="12" sm="12" md="12" lg="12">
        <!-- <span class="label"> Scanned copy of documents proving ownership of land in the name of the Applicant (along with map, if available) </span> : -->
        <span class="label"> Scanned copies of the relevant documents mentioned in the EOI </span><span class="text-danger">*</span> :
    <b-icon
        icon="info-circle"
        variant="primary"
        class="ml-2"
        v-b-tooltip.hover
        title=" Max file Size is 10MB"
        style="cursor: pointer;"
      ></b-icon> 

      </b-col>
      <b-col col cols="7" sm="4" md="4" lg="3">
        <b-form-file  plain id="uploadLandDoc"></b-form-file>
      </b-col>
    </b-row>
          <b-row>
            <b-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-content-center">
				<b-button @click="goToPreviousStep" variant="secondary">Back</b-button>
				<b-button @click="goToNextStep" variant="primary">Next</b-button>
            </b-col>
          </b-row>
		  
        </div>
		<div v-if="currentStep === 3">
    
      <div class="custom-box-shadow mb-4">
        <h4 class="title-style">
          PREVIEW APPLICATION 
          <small class="text-muted" style="padding-top: 0.2rem;padding-left: 0.4rem;font-size: 0.85rem; color:red !important;">(Note: Once submitted, the application cannot be modified)</small>
        </h4>
      </div>

    
    <div class="application-preview">
      
      
      <div class="section">
       <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Applicant Information" label-for="Applicant Information" class="custom-label"></b-form-group>
          <hr style="border-top: 1px dashed #000; margin: 10px 0;">
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Applicant Name:">
              <b-form-input v-model="applicantName" size="sm" class="line-input" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Applicant Email:">
              <b-form-input v-model="applicantEmail" size="sm" class="line-input" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Applicant Mailing Adress:">
              <b-form-input v-model="applicantMailAddress" size="sm" class="line-input" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Permanent/Registered Postal Address:">
              <b-form-input v-model="applicantPermanentAddress" size="sm" class="line-input" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Applying as:">
              <b-form-input 
      
       :value="applyingAsComputed"
      size="sm"  
      disabled
       
    ></b-form-input>
            </b-form-group>
          </b-col>
          
         
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Year of Incorporation:">
              <b-form-input v-model="incorpYear" size="sm" class="line-input" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Number of Years in Operation:">
              <b-form-input v-model="opYears" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Website:">
              <b-form-input v-model="applicantWebsite" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="PAN:">
              <b-form-input v-model="applicantPAN" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <!--<b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Mobile:">
              <b-form-input v-model="applicantMobile" disabled></b-form-input>
            </b-form-group>
          </b-col>-->
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Is the Vendor registered under GST?:">
              <b-form-input v-model="isGSTRegistered" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        
		<b-row>
          
       
    <b-col v-if="isGSTRegistered !== 'No' "cols="12" sm="12" md="6" lg="6">
      <b-form-group label="GSTN:">
        <b-form-input v-model="applicantGST" disabled></b-form-input>
      </b-form-group>
    </b-col>
    <b-col v-if="isGSTRegistered !== 'No'" cols="12" sm="12" md="6" lg="6">
      <b-form-group label="GSTN Address:">
        <b-form-input v-model="applicantGSTNadd" disabled></b-form-input>
      </b-form-group>
    </b-col>
  </b-row>
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Has the Bidder/ Company ever been debarred by any Govt. Dept./ Undertaking for undertaking any work?:">
              <b-form-input v-model="isDebarred" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col  v-if="isDebarred !== 'No'"cols="12" sm="12" md="6" lg="6">
            <b-form-group label="debarred Details:">
              <b-form-input v-model="debarredDetails" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  
        </b-row>
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Whether company is MSME as on the bidding date?:">
              <b-form-input v-model="isMsme" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col v-if="isMsme !== 'No'" cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Msme Details:">
              <b-form-input v-model="MsmeDetails" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  
        </b-row>
      </div>


     
      <div class="section">
        <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Details of authorized Contact Person(s) / Fax No. to whom all references shall be made" label-for="AuthorizedPerson" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group>
  <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Name:">
              <b-form-input v-model="PoAName" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Designation:">
              <b-form-input v-model="PoADesignation"size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		 <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Email:">
              <b-form-input v-model="PoAEmailId" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Postal Address:">
              <b-form-input v-model="PoAPostalAddress"size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		<b-row>
         

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="MobileNo:">
              <b-form-input v-model="PoAMobileNo"size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      
      <div class="section">
        <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Basic Land Details" label-for="LandDetails" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;"></b-form-group>
  
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Village:">
              <b-form-input v-model="Village" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Tehsil:">
              <b-form-input v-model="Tehsil" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		 <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="State:">
              <b-form-input v-model="State" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="District:">
              <b-form-input v-model="District" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Coordinates:">
              <b-form-input v-model="Coordinates" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Approx area Available (Acre):">
              <b-form-input v-model="ApproxArea" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		
      </div>
      <div class="section">
        <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Type of Land (as per revenue records)" label-for="LandType" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group>
  
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Is the Land Cultivable?:">
              <b-form-input v-model="isLandCultivable" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>

        </b-row>
		
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Is Agricultural Permission Required?:">
              <b-form-input v-model="isAgriPermission" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col v-if="isAgriPermission !== 'No'" cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Scope of Agricultural permission:">
              <b-form-input v-model="scopeAgriculture" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  
        </b-row>
		
		<b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="SC/ST land?:">
              <b-form-input v-model="isscstLand" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
          
          <b-col v-if="isscstLand !== 'No'" cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Enter details about area in Acres:">
              <b-form-input v-model="areainAcres" disabled></b-form-input>
            </b-form-group>
          </b-col>
		   <b-col v-if="isscstLand !== 'No'" cols="12" sm="12" md="6" lg="6">
            <b-form-group label="No of Surveys:">
              <b-form-input v-model="noofSurveys" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  
        </b-row>


      </div>

<div class="section">

  <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Land ownership details" label-for="LandOwnershipDetails" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
    
  </b-form-group>
  
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Ownership Details:">
              <b-form-input v-model="ownershipDetails" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Acquisition Status:">
              <b-form-input v-model="acquisitionStatus" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>



</div>

<div class="section">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Trees cutting requirement" label-for="Treescuttingrequirement" class="custom-label">
    <hr style="border-top: 1px dashed #000; margin: 10px 0;"></b-form-group>



</div>

<div class="section">
        <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Tentative requirement of tree cutting:">
              <b-form-input v-model="treeRequirement" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Type of trees::">
              <b-form-input v-model="treeTypes" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		
		</div>
		<div class="section"> 
		
      <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Connectivity / Approach to site" label-for="connectivitysite" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group>
  <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Number of Access roads connecting to site::">
              <b-form-input v-model="noofaccessRoad" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Nearby Major Highways(National/State Highway/District Roads etc):">
              <b-form-input v-model="majorHighways" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
		</div>
      <div class="section">
	<hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Physical Status of Land &preliminary Details about strata / topography / terrain" label-for="physicalstatusland" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group>
  
  <b-row>
          <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Flat/Undulated terrain:">
              <b-form-input v-model="terrainStatus" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
            <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Physical occupation status of land:">
              <b-form-input v-model="physicalOccupation" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
  
  <b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Any existing structures inside the land parcels?:">
              <b-form-input v-model="existingStructure" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Presence of forest land, protected land, religious land, graveyard etc.?::">
              <b-form-input v-model="presenceLand" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
  
		</b-row>
		<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Presence of any unusable / Waste area (Acre)?:">
              <b-form-input v-model="presencewasteArea" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Presence of any active gas Pipe lines/ electrical cable network etc.?:" label-for="presencegaspipelines:">
   
              <b-form-input v-model="presencegaspipelines" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
  
		</b-row>
		</div>
          
          <div class="section"> 
		   <hr style="border-top: 1px dashed #000; margin: 10px 0;"><b-form-group label="Power Evacuation & Transmission Line" label-for="powerLine" class="custom-label">
  <hr style="border-top: 1px dashed #000; margin: 10px 0;">
    
  </b-form-group>
  
  <b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Nearest Substation:">
              <b-form-input v-model="nearestSubstation" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Ownership of Substation:" label-for="ownershipSubstation">
   
              <b-form-input v-model="ownershipSubstation" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
  
		</b-row>
		<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Coordinates of Substation:">
              <b-form-input v-model="coordinatesSubstation" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Voltage Levels:" label-for="voltageLevels">
   
              <b-form-input v-model="voltageLevels" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
  
		</b-row>
		<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Arial Distance from Site:" label-for="aerialDistance">
              <b-form-input v-model="aerialDistance" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Tentative route length from Site:" label-for="routeLength">
   
              <b-form-input v-model="routeLength" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
  
		</b-row>
		  
		  
		  <b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Railway/NH crossing?:" label-for="railwayorNHcrossing">
              <b-form-input v-model="railwayorNHcrossing" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Forest Crossing?:" label-for="forestCrossing">
   
              <b-form-input v-model="forestCrossing" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
  
		</b-row>
		<b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
            <b-form-group label="Populated Area crossing?:" label-for="populatedAreacrossing">
              <b-form-input v-model="populatedAreacrossing" size="sm" disabled></b-form-input>
            </b-form-group>
          </b-col>
		  
  
		</b-row>
		  
    <b-row>
  <b-col cols="12" sm="12" md="6" lg="6">
    <b-form-group label>
    <span >Scanned copies of the relevant documents mentioned in the EOI:</span> <b-form-input  placeholder="uploaded" size="sm" disabled></b-form-input>
  </b-form-group>
          </b-col>
		  
  
		</b-row>
    
		  </div>
      <div class="section text-center">
        <b-row>
          <b-col cols="12">
            <b-button @click="goToPreviousStep" variant="secondary">Back</b-button>
            <b-button @click="submitForm()"  id="saveApplicationbutton" variant="primary">Submit</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
		
      </b-form>
    </b-card> 


    </br>
</div>

  <br>
</b-container>

</b-overlay>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>

    <b-modal id="SolarApplicationSuccessModal" centered  scrollable title="Save Application" hide-footer hide-header>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="29.8,67.5 51.5,88.8 100.2,40.2"/>
      </svg>
      <p class="success">Application Successfully Submitted !<br><br>
      <b-button class="btn btn-outline" variant="success" id=""  @click="reloadPage()">OK </b-button>
      </p>
    </b-modal>
    <b-modal id="SolarApplicationFailureModal" centered  scrollable title="Save Application" hide-footer hide-header>
      <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
      </svg>
      <p class="error">Application could not be submitted !<br><br>
      <b-button variant="outline-primary" id="" @click="reloadPage()" >OK </b-button>
      
      </p>
    </b-modal>
  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var thColor = '#0288d1';
var accessToken="";

export default {
  name: '',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  data() {
    return {

    
    show: false,
	  currentStep: 1, // Track the current step (1 for Applicant, 2 for Land)
    applicantName: '',
    applicantEmail: '',
    applicantMailAddress:'',
    applicantPermanentAddress:'',
    applicantWebsite:'',
    applicantPAN:'',
    applicantMobile:'',
    incorpYear:'',
    opYears:'',
    applyingAs: '',
    otherText:'',
    isGSTRegistered: '',
    applicantGST: '',
    applicantGSTNadd:'',
    isDebarred:'',
    debarredDetails:'',
    isMsme:'',
    MsmeDetails:'',
    PoAName:'',
    PoADesignation:'',
    PoAEmailId:'',
    PoAPostalAddress:'',
    PoAEmailId:'',
    PoAMobileNo:'',
    State: 'Assam',
    District: '',
    Village:'',
    Tehsil:'',
    Coordinates:'',
    ApproxArea:'',
    landDocFile: null,
    isLandCultivable:'',
    isAgriPermission:'',
    scopeAgriculture:'',
    isscstLand:'',
    areainAcres:'',
    noofSurveys:'',
    ownershipDetails:'',
    treeRequirement:'',
    treeTypes:'',
    noofaccessRoad:'',
    majorHighways:'',
    existingStructure:'',
    nearestSubstation:'',
    ownershipSubstation:'',
    coordinatesSubstation:'',
    voltageLevels:'',
    aerialDistance:'',
    routeLength:'',
    acquisitionStatus:'',
    terrainStatus:'',
    physicalOccupation:'',
    existingStructure:'',
    presenceLand:'',
    presencegaspipelines:'',
    ownershipSubstation:'',
    railwayorNHcrossing:'',
    forestCrossing:'',
    populatedAreacrossing:'',
    presencewasteArea:'',
    isSameAddress: false,

    isAgriPermissionOptions:[
   
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    isLandCultivableOptions:[
    
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    isscstLandOptions:[
    
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    MsmeOptions:[
    
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    
    DebarredOptions:[ 
    
      { value: 'Yes', text: 'Yes' },
      { value: 'No', text: 'No' }],
    gstOptions: [
    
        { value: 'Yes', text: 'Yes' },
        { value: 'No', text: 'No' }
      ],
	applyingOptions: [
        { value: '', text: 'Please select an option' }, 
        { value: 'privateLandOwners', text: 'Private Land Owners' },
        { value: 'landAggregator', text: 'Land Aggregator' },
        { value: 'entrepreneurs', text: 'Entrepreneurs/ Sole Proprietorships' },
        { value: 'partnerships', text: 'Partnerships' },
        { value: 'llp', text: 'Limited Liability Partnerships' },
        { value: 'consortium', text: 'Consortium' },
        { value: 'companies', text: 'Companies' },
        { value: 'cooperativeSocieties', text: 'Cooperative Societies' },
        { value: 'registeredNgo', text: 'Registered NGO' },
        { value: 'registeredTrust', text: 'Registered Trust' },
        { value: 'governmentAgencies', text: 'Government Agencies' },
        { value: 'governmentCompanies', text: 'Government Companies' },
        { value: 'psu', text: 'Public Sector Undertakings' },
        { value: 'others', text: 'Others (To be specified)' },
      ],
      
      districtOptions: [
      { value: null, text: 'Select District' },
    { value: 'BAJALI', text: 'BAJALI' },
    { value: 'BAKSA', text: 'BAKSA' },
    { value: 'BARPETA', text: 'BARPETA' },
    { value: 'BISWANATH', text: 'BISWANATH' },
    { value: 'BONGAIGAON', text: 'BONGAIGAON' },
    { value: 'CACHAR', text: 'CACHAR' },
    { value: 'CHARAIDEO', text: 'CHARAIDEO' },
    { value: 'CHIRANG', text: 'CHIRANG' },
    { value: 'DARRANG', text: 'DARRANG' },
    { value: 'DHEMAJI', text: 'DHEMAJI' },
    { value: 'DHUBRI', text: 'DHUBRI' },
    { value: 'DIBRUGARH', text: 'DIBRUGARH' },
    { value: 'GOALPARA', text: 'GOALPARA' },
    { value: 'GOLAGHAT', text: 'GOLAGHAT' },
    { value: 'HAILAKANDI', text: 'HAILAKANDI' },
    { value: 'HOJAI', text: 'HOJAI' },
    { value: 'JORHAT', text: 'JORHAT' },
    { value: 'KAMRUP', text: 'KAMRUP' },
    { value: 'KAMRUP METROPOLITAN', text: 'KAMRUP METROPOLITAN' },
    { value: 'KARBI ANGLONG', text: 'KARBI ANGLONG' },
    { value: 'KARIMGANJ', text: 'KARIMGANJ' },
    { value: 'KOKRAJHAR', text: 'KOKRAJHAR' },
    { value: 'LAKHIMPUR', text: 'LAKHIMPUR' },
    { value: 'MAJULI', text: 'MAJULI' },
    { value: 'MORIGAON', text: 'MORIGAON' },
    { value: 'NALBARI', text: 'NALBARI' },
    { value: 'NAGAON', text: 'NAGAON' },
    { value: 'SIVASAGAR', text: 'SIVASAGAR' },
    { value: 'SONITPUR', text: 'SONITPUR' },
    { value: 'TAMULPUR', text: 'TAMULPUR' },
    { value: 'TINSUKIA', text: 'TINSUKIA' },
    { value: 'UDALGURI', text: 'UDALGURI' },
    { value: 'WEST KARBI ANGLONG', text: 'WEST KARBI ANGLONG' }
      ],
      acquisitionStatusOptions: [
        { value: '', text: 'Please select an option' }, 
        { value: 'ExtentofATS ', text: 'Extent of ATS ' },
        { value: 'SaleDeed ', text: 'Sale Deed ' },
      ],
      terrainStatusOptions: [
        { value: '', text: 'Please select an option' }, 
        { value: 'Flat ', text: 'Flat terrain' },
        { value: 'Undulated ', text: 'Undulated terrain ' },
      ],
      ownershipSubstationOptions: [
        { value: '', text: 'Please select an option' }, 
        { value: 'DISCOM', text: 'DISCOM' },
        { value: 'STU ', text: 'STU' },
        { value: 'CTU', text: 'CTU' },
      
      ],
      existingStructureOptions:[
      { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }
  ],
  presenceLandOptions:[
  { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    presencegaspipelinesOptions:[
    { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    railwayorNHcrossingOptions:[
    { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    forestCrossingOptions:[
    { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    populatedAreacrossingOptions:[
    { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    presencewasteAreaOptions:[
    { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' }],
    }
  },
  computed: {
  
  applyingAsComputed() {
    if (this.applyingAs === 'others' && this.otherText.trim()) {
      return `Others: ${this.otherText}`;
    }
    return this.applyingAs; 
  }
},
  mounted(){
      window.scrollTo(0, 0);
    },

  methods: {
    
    closeModal(){
      this.$bvModal.hide('model')
    },
	

    reloadPage()
      {
        window.location.reload();
      },
      sameAddress() {
    if (this.isSameAddress) {
        
        this.applicantPermanentAddress = this.applicantMailAddress;
    } else {
        
        this.applicantPermanentAddress = ''; 
    }
},

		goToNextStep() {

      var name = this.applicantName;
      var email=this.applicantEmail;
      var poaEmail=this.PoAEmailId;
      var applyingAs = this.applyingAs;
      console.log("applyingAs::"+applyingAs);
      var mobregx = /^[5-9]\d{9}$/
      var mobile = this.PoAMobileNo.trim();
      var emailReg = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9]{1}$/;
      var applicantPAN = this.applicantPAN.trim();
      var applicantGSTN = this.applicantGST.trim();
      //console.log("GST",applicantGSTN);
     
      //validations check 
      if (this.currentStep === 1) {
        
        if (!name) 
        {

          
    this.$bvToast.toast('Enter Applicant Name!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("applicantName").focus();
    return;
  }
 
  if(!email || !emailReg.test(email))
      {
        
        this.$bvToast.toast('Enter Valid Email of applicant!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("applicantEmail").focus();
        return;
      } 


     
  if (!this.applicantMailAddress) {
    this.$bvToast.toast('Enter Applicant Mail Address !', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("applicantMailAddress").focus();
    return;
  }
  if (!this.applicantPermanentAddress) {
    this.$bvToast.toast('Enter Applicant Permanent Address !', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("applicantPermanentAddress").focus();
    return;
  }
  
 if (!applyingAs) {
    this.$bvToast.toast('Select your applying as !', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("applyingAs").focus();
    return;
  }

   if (this.applyingAs === 'others' && !this.otherText) {
      this.$bvToast.toast('Please specify!', {
        title: 'Alert',
        variant: 'danger',
        solid: true
      });
      document.getElementById("otherText").focus();
      return false;
    }

  if (!this.incorpYear) {
    this.$bvToast.toast('Enter Year of Incorporation !', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("incorpYear").focus();
    return;
  }

  if (!this.opYears) {
    this.$bvToast.toast('Enter Number of Years in Operation !', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("opYears").focus();
    return;
  }
  if (!applicantPAN || !panRegex.test(applicantPAN)) {
    this.$bvToast.toast('Enter valid PAN of applicant !', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("applicantPAN").focus();
    return;
  }
  if (!this.isGSTRegistered) {
    this.$bvToast.toast('Select if applicant is GST registered!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("isGSTRegistered").focus();
    return;
  }
  if (this.isGSTRegistered === 'Yes') {

    if (!applicantGSTN || !gstRegex.test(applicantGSTN)) {
    this.$bvToast.toast('Enter valid GST of applicant !!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("applicantGST").focus();
    return;
  }
  if (!this.applicantGSTNadd) {
    this.$bvToast.toast('Enter GST address of applicant !!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("applicantGSTNadd").focus();
    return;
  }
  }
  

  if (!this.isDebarred) {
    this.$bvToast.toast('Select if the Bidder/ Company ever been debarred!!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("isDebarred").focus();
    return;
  }

  if (this.isDebarred === 'Yes'){

 if (!this.debarredDetails) {
    this.$bvToast.toast('Enter Debarred details!!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("debarredDetails").focus();
    return;
  }

  }

  if (!this.isMsme) {
    this.$bvToast.toast('Select if the  Company is MSME!!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("isMsme").focus();
    return;
  }

  if (this.isMsme === 'Yes'){

 if (!this.MsmeDetails) {
    this.$bvToast.toast('Enter Msme details!!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("MsmeDetails").focus();
    return;
  }

  }

  if (!this.PoAName) {
    this.$bvToast.toast('Enter Authorized Person Name!!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("PoAName").focus();
    return;
  }

  if (!this.PoADesignation) {
    this.$bvToast.toast('Enter Authorized Person Designation!!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("PoADesignation").focus();
    return;
  }
  
  if(!poaEmail || !emailReg.test(poaEmail))
      {
        
        this.$bvToast.toast('Enter valid  Mail ID of the Authorized Person!!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("PoAEmailId").focus();
        return;
      } 

  if (!this.PoAPostalAddress) {
    this.$bvToast.toast('Enter Authorized Person Postal Address!!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("PoAPostalAddress").focus();
    return;
  }
  if (!mobile || !mobregx.test(mobile)) {
    this.$bvToast.toast('Enter valid 10 digit Mobile Number!!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("PoAMobileNo").focus();
    return;
  }
  
          this.currentStep = 2; // Move to Land Details
          window.scrollTo(0, 0);
         // console.log("entered step2")
      } 
      else if (this.currentStep === 2) {
        
        if (!this.Village) {
    this.$bvToast.toast('Enter  Village Name!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("Village").focus();
    return;
  }

  if (!this.Tehsil) {
    this.$bvToast.toast('Enter Tehsil!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("Tehsil").focus();
    return;
  }
  

  if (!this.District) {
    this.$bvToast.toast('Select District!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("District").focus();
    return;
  }
  if (!this.Coordinates) {
    this.$bvToast.toast('Enter Coordinates!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("Coordinates").focus();
    return;
  }
   /*if (!this.ApproxArea || this.ApproxArea > 5) {
    this.$bvToast.toast('Enter Approx Area of min 5acre contiguous land!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("ApproxArea").focus();
    return;
  }*/


  if (!this.ApproxArea) {
    this.$bvToast.toast('Enter Approx Area of min 5acre contiguous land!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("ApproxArea").focus();
    return;
  }
  if (!this.isLandCultivable) {
    this.$bvToast.toast('Select if  the Land Cultivable?!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("isLandCultivable").focus();
    return;
  }
  if (!this.isAgriPermission) {
    this.$bvToast.toast('Select if  Agricultural Permission required!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("isAgriPermission").focus();
    return;
  }

  if (this.isAgriPermission=='Yes') {

    if (!this.scopeAgriculture) {
    this.$bvToast.toast('Enter Scope of Agricultural Permisison!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("scopeAgriculture").focus();
    return;
  }
    
  }

  if (!this.isscstLand) {
    this.$bvToast.toast('Select if  SC/ST Land!', {
      title: 'Alert',
      variant: 'danger',
      solid: true
    });
    document.getElementById("isscstLand").focus();
    return;
  }

  if (this.isscstLand=='Yes') {

if (!this.areainAcres) {
this.$bvToast.toast('Enter area in Acres!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("areainAcres").focus();
return;
}

if (!this.noofSurveys) {
this.$bvToast.toast('Enter no of Surveys!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("noofSurveys").focus();
return;
}

}
if (!this.ownershipDetails) {
this.$bvToast.toast('Enter ownership Details!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("ownershipDetails").focus();
return;
}
if (!this.acquisitionStatus) {
this.$bvToast.toast('Enter Acquisition Status!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("acquisitionStatus").focus();
return;
}
if (!this.treeRequirement) {
this.$bvToast.toast('Enter tree cutting requirement!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("treeRequirement").focus();
return;
}
if (!this.treeTypes) {
this.$bvToast.toast('Enter tree Types!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("treeTypes").focus();
return;
}
if (!this.noofaccessRoad) {
this.$bvToast.toast('Enter no of access Road!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("noofaccessRoad").focus();
return;
}
if (!this.majorHighways) {
this.$bvToast.toast('Enter major Highways!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("majorHighways").focus();
return;
}
if (!this.terrainStatus) {
this.$bvToast.toast('Select terrain Status!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("terrainStatus").focus();
return;
}
if (!this.physicalOccupation) {
this.$bvToast.toast('Enter physical Occupation Status!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("physicalOccupation").focus();
return;
}

if (!this.existingStructure) {
this.$bvToast.toast('Select if  existing Structure?!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("existingStructure").focus();
return;
}

if (!this.presenceLand) {
this.$bvToast.toast('Select if  presence of forest,protected Land etc?!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("presenceLand").focus();
return;
}
if (!this.presencewasteArea) {
this.$bvToast.toast('Select if  presence of wasteArea?!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("presencewasteArea").focus();
return;
}
if (!this.presencegaspipelines) {
this.$bvToast.toast('Select if  presence of utility pipelines?!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("presencegaspipelines").focus();
return;
}
if (!this.nearestSubstation) {
this.$bvToast.toast('Enter Nearest Substation!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("nearestSubstation").focus();
return;
}
if (!this.ownershipSubstation) {
this.$bvToast.toast('Enter ownership of Substation!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("ownershipSubstation").focus();
return;
}

if (!this.coordinatesSubstation) {
this.$bvToast.toast('Enter coordinates of Substation!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("coordinatesSubstation").focus();
return;
}
if (!this.voltageLevels) {
this.$bvToast.toast('Enter voltageLevels!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("voltageLevels").focus();
return;
}

if (!this.aerialDistance) {
this.$bvToast.toast('Enter aerial Distance!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("aerialDistance").focus();
return;
}
if (!this.routeLength) {
this.$bvToast.toast('Enter route Length!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("routeLength").focus();
return;
}

if (!this.railwayorNHcrossing) {
this.$bvToast.toast('select if railway or NHcrossing?!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("railwayorNHcrossing").focus();
return;
}

if (!this.forestCrossing) {
this.$bvToast.toast('select if forest Crossing?!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("forestCrossing").focus();
return;
}


if (!this.populatedAreacrossing) {
this.$bvToast.toast('select if populated Area crossing?!', {
  title: 'Alert',
  variant: 'danger',
  solid: true
});
document.getElementById("populatedAreacrossing").focus();
return;
} 
        const fileInput = document.querySelector('#uploadLandDoc');
       // console.log("fileInput:::::", fileInput);

        if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
          this.$bvToast.toast('Please attach a PDF file!', {
            title: 'No File Selected',
            variant: 'danger',
            solid: true
          });
          return;
        }

        
        this.landDocFile = fileInput?.files?.[0] || null;
        if (this.landDocFile.type !== "application/pdf") {
          this.$bvToast.toast('Only PDF files are allowed!', {
            title: 'Invalid File Type',
            variant: 'danger',
            solid: true
          });
          event.target.value = "";
          this.landDocFile = null;
          return;
        }

        const maxSize = 10 * 1024 * 1024;
        if (this.landDocFile.size > maxSize) {
          this.$bvToast.toast('File must be 10MB or smaller!', {
            title: 'File Too Large',
            variant: 'danger',
            solid: true
          });
          fileInput.value = "";
          this.landDocFile = null;
          return;
        }

       //console.log("file typeL:::::"+this.landDocFile.type);

        this.currentStep = 3; // Move to Summary
        window.scrollTo(0, 0);
        //console.log("Step3")
      } 
      else {
        this.$bvToast.toast('Please fill out all fields before proceeding.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
      
    },	
	goToPreviousStep() {
      if (this.currentStep === 3) {
        window.scrollTo(0, 0);
        this.currentStep = 2; 
      } else if (this.currentStep === 2) {
        window.scrollTo(0, 0);
        this.currentStep = 1; 
      }
    },

    /* ****SUbmit Form Function******** */

  submitForm(){

  const file = this.landDocFile;
 // console.log("Selected file:::", file);

  const formData = new FormData();
  formData.append('uploadFile', this.landDocFile);
  // console.log("formData is showing::::"+formData);
  // console.log("rest api::::"+this.$urlRestapi);

  var parent =this;
  parent.show= true;
  document.getElementById('saveApplicationbutton').disabled = true;

  try{
    axios.post("https://www.apdclrms.com/restapi/v2/website/landAcquision/uploadLandDocs",formData,{
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
              }).then(function(response) {
              console.log("response data file upload::::::"+JSON.stringify(response.data));

              var status = response.data.status;
              

              if(status == "success")
              {
                  const dataToSend = JSON.stringify({
                    registeredName: parent.applicantName,
                    email: parent.applicantEmail,
                    mailingAddress: parent.applicantMailAddress,
                    permanentAddress: parent.applicantPermanentAddress,
                    applyingAs:parent.applyingAsComputed,
                    yearOfIncorporation: parent.incorpYear,
                    yearsInOperation: parent.opYears,
                    website: parent.applicantWebsite,
                    panNumber: parent.applicantPAN,
                    gstRegistered: parent.isGSTRegistered,
                    gstId: parent.applicantGST,
                    gstnAddress: parent.applicantGSTNadd,
                    debarred: parent.isDebarred,
                    debarredReason: parent.debarredDetails,
                    msmeRegistered: parent.isMsme,
                    msmeDetails: parent.MsmeDetails,
                    contactPersonName: parent.PoAName,
                    contactPersonDesignation: parent.PoADesignation,
                    contactPersonAddress: parent.PoAPostalAddress,
                    contactPersonMobile: parent.PoAMobileNo,
                    contactPersonEmail: parent.PoAEmailId,
                    village: parent.Village,
                    tehsil: parent.Tehsil,
                    district: parent.District,
                    state: parent.State,
                    approxAreaAvailable: parent.ApproxArea,
                    coordinates: parent.Coordinates,
                    cultivable: parent.isLandCultivable,
                    agriculturePermissionRequired: parent.isAgriPermission,
                    scopeOfAgriculturePermission: parent.scopeAgriculture,
                    scStLand: parent.isscstLand,
                    scStLandArea: parent.areainAcres,
                    scStLandSurvey: parent.noofSurveys,
                    ownershipDetails: parent.ownershipDetails,
                    acquisitionStatus: parent.acquisitionStatus,
                    tentativeTreeCutting: parent.treeRequirement,
                    typeOfTrees: parent.treeTypes,
                    accessRoadsCount: parent.noofaccessRoad,
                    nearbyMajorHighways: parent.majorHighways,
                    terrainType: parent.terrainStatus,
                    physicalOccupationStatus: parent.physicalOccupation,
                    existingStructures: parent.existingStructure,
                    protectedLandPresence: parent.presenceLand,
                    wasteAreaPresence: parent.presencewasteArea,
                    utilityNetworkPresence: parent.presencegaspipelines,
                    nearestSubstation: parent.nearestSubstation,
                    substationOwnership: parent.ownershipSubstation,
                    substationCoordinates: parent.coordinatesSubstation,
                    voltageLevels: parent.voltageLevels,
                    aerialDistance: parent.aerialDistance,
                    tentativeRouteLength: parent.routeLength,
                    railwayNhCrossing: parent.railwayorNHcrossing,
                    forestCrossing: parent.forestCrossing,
                    populatedAreaCrossing: parent.populatedAreacrossing,
                    uploadLink: response.data.message
                });

                console.log("link::::"+response.data.message);

                let config = {
                  method: 'post',
                  maxBodyLength: Infinity,
                  url: parent.$urlCommon+'/api/web/land/register',
                  headers: { 
                    'Content-Type': 'application/json'
                  },
                  data:dataToSend
                };
                try {
                  axios.request(config)
                  .then(function(response) {
                      parent.show=false;
                      
                    if(response.data == "Vendor registration successful") {
                      parent.$bvModal.show('SolarApplicationSuccessModal');
                    }
                    else {
                      parent.$bvModal.show('SolarApplicationFailureModal');
                    }
                      document.getElementById('saveApplicationbutton').disabled = false;
                    });
                  }catch (error) {
                      console.error("Error calling server", error.message);
                  }

                  return;
              }
              else{
                parent.$bvModal.show('model');
                document.getElementById('modalMsg').innerHTML = "Error in data upload!"
              }
            })
  }catch (error){
    console.error("Error calling server");
  }
},

/*setTimeout(() => {
      window.location.reload();
    }, 2000);*/

}
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;


   
    

</script>

<style scoped="true">
.fixed-overlay {
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1050; /* Make sure it's above most elements */
}

.blink {
    animation: blinkText 1.5s infinite;
  }

  @keyframes blinkText {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
  }

  .hover-underline:hover {
    text-decoration: underline;
  }

.input {
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.label {
  font-weight: 600;
}
.custom-box-shadow {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 12px -4px;
  justify-content: center; 
  background-color: rgb(237, 242, 245);
  border-radius: 8px;
  padding: 10px;
  font-family: 'Roboto', sans-serif;
  align-items: center;
  
}
.centered-container {
 
  justify-content: center; 
  align-items: center; 
  height: 100%; 
}
.centered-tab {
  display: flex;
  justify-content: center;
  
  background-color:  #0d9ab9;
  padding: 10px;
  border-radius: 5px; 
  
  color: #333; 
  font-size: 18px; 
  font-weight: bold; 
}

.custom-label {
  font-weight: bold;
  font-size: 1.1rem;
  color: #2c3e50; 
  margin-bottom: 8px;
}



.title-style {
  display: flex;
  
  font-size: 18px;
  font-weight: bold;
  color: #333;
  /*text-decoration: underline; margin-bottom: 10px;*/
  
  padding: 10px;
  
}

.btn {
  padding: 10px 15px;
  margin: 5px;
  background-color: #0d9ab9;
  
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.btn:hover {
  background-color: #0056b3;
}
td{
  padding:0.3rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}
.showDetails
{
 visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}
.modalFont{
    width: 100px;
    display: block;
    margin: 40px auto 0;
  }
  .path.circle {
    stroke-dasharray: 390;
    stroke-dashoffset: 390;
    animation: dash-circle 1s ease-in-out forwards;
  }

  .path.check {
      stroke-dasharray: 150;
      stroke-dashoffset: 150;
      animation: dash-check 0.5s 1s ease-in-out forwards;
  }

  @keyframes dash-circle {
      to {
          stroke-dashoffset: 0;
      }
  }

  @keyframes dash-check {
      to {
          stroke-dashoffset: 0;
      }
  }
  p {
    text-align: center;
    margin: 20px 0 60px;
    font-size: 1.25em;
  }
  p.success {
    color: #73AF55;
  }
  p.error {
    color: #D06079;
  }

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }

    .application-preview {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  margin: 0 auto;
}

.section {
  margin-bottom: 20px;
}

.section-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.title-style {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.custom-box-shadow {
  background: #f8f8f8;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
}

.b-form-input {
  font-size: 16px;
}

.b-button {
  margin: 10px;
}

.text-center {
  text-align: center;
}
  }
</style>
